import { render, staticRenderFns } from "./MyInvitate.vue?vue&type=template&id=06e891da&scoped=true"
import script from "./MyInvitate.vue?vue&type=script&lang=js"
export * from "./MyInvitate.vue?vue&type=script&lang=js"
import style0 from "./MyInvitate.vue?vue&type=style&index=0&id=06e891da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e891da",
  null
  
)

export default component.exports